module.exports = __webpack_public_path__ + "media/images/flags/16/Macau-d6a9bab1abed48a0df41e5648a7223a7.png";